export class AccountSearchItem implements IAccountSearchItem {
  id?: string;
  companyName?: string | undefined;
  customerKey?: string | undefined;
  abn?: string | undefined;
  dateCreated?: Date;
  dateUpdated?: Date;
  state?: string | undefined;
  countryCode?: string | undefined;
  isDisabled?: boolean;

  constructor(data?: IAccountSearchItem) {
    if (data) {
      for (const property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.companyName = _data['companyName'];
      this.customerKey = _data['customerKey'];
      this.abn = _data['abn'];
      this.dateCreated = _data['dateCreated'] ? new Date(_data['dateCreated'].toString()) : <any>undefined;
      this.dateUpdated = _data['dateUpdated'] ? new Date(_data['dateUpdated'].toString()) : <any>undefined;
      this.state = _data['state'];
      this.countryCode = _data['countryCode'];
      this.isDisabled = _data['isDisabled'];
    }
  }

  static fromJS(data: any): AccountSearchItem {
    data = typeof data === 'object' ? data : {};
    const result = new AccountSearchItem();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['companyName'] = this.companyName;
    data['customerKey'] = this.customerKey;
    data['abn'] = this.abn;
    data['dateCreated'] = this.dateCreated ? this.dateCreated.toISOString() : <any>undefined;
    data['dateUpdated'] = this.dateUpdated ? this.dateUpdated.toISOString() : <any>undefined;
    data['state'] = this.state;
    data['countryCode'] = this.countryCode;
    data['isDisabled'] = this.isDisabled;
    return data;
  }
}

export interface IAccountSearchItem {
  id?: string;
  companyName?: string | undefined;
  customerKey?: string | undefined;
  abn?: string | undefined;
  dateCreated?: Date;
  dateUpdated?: Date;
  state?: string | undefined;
  countryCode?: string | undefined;
  isDisabled?: boolean;
}